module.exports = __webpack_public_path__ + "img/logo_be_vallet_pnud.94b54c9a.png";